module.exports = __webpack_public_path__ + "img/Accountor-17-lowres.72440c1d.jpg";